import SocialsService from "../services/SocialsService";
const defaultState = () => {
  return {
    limit: 3,
    offset: 0,
    isLoadingPosts: false,
    posts: [],
    scrollPositions: [],
    surveyStep: "scroll",
    surveyStepDuration: 45,
    showPrompt: true,
    stimulusIsLiked:false,
  };
};

const state = defaultState();

const getters = {
  getPosts: (state) => state.posts,
  getSurveyStep: (state) => state.surveyStep,
  getSurveyStepDuration: (state) => state.surveyStepDuration,
  getShowPrompt: (state) => state.showPrompt,
  getStimulusIsLiked:(state)=>state.stimulusIsLiked,
};

const mutations = {
  RESET_STATE: (state) => {
    const s = defaultState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
  SET_OFFSET: (state, offset) => (state.offset = offset),
  SET_SURVEY_STEP: (state, surveyStep) => (state.surveyStep = surveyStep),
  SET_SURVEY_STEP_DURATION: (state, surveyStepDuration) =>
    (state.surveyStepDuration = surveyStepDuration),
  SET_SHOW_PROMPT: (state, showPrompt) => (state.showPrompt = showPrompt),
  SET_SCROLL_POSITION: (state, position) =>
    state.scrollPositions.push(position),
  ADD_POSTS: (state, posts) => state.posts.push(...posts),
  SET_IS_LOADING_POSTS: (state, loading) => (state.isLoadingPosts = loading),
  SET_POST_IS_FOLLOWED: (state, id) => {
    state.posts[id].isFollowed = true;
  },
  SET_POST_IS_LIKED: (state, id) => {
    state.posts[id].isLiked
      ? --state.posts[id].bodyParsed.footer.reactionsCounter
      : ++state.posts[id].bodyParsed.footer.reactionsCounter;
    state.posts[id].isLiked = !state.posts[id].isLiked;
    if(state.posts[id].isStimulus)
      state.stimulusIsLiked=!state.stimulusIsLiked
  },
  SET_POST_COMMENT: (state, { id, comment }) => {
    state.posts[id].comments.push(comment);
    ++state.posts[id].bodyParsed.footer.commentsCounter;
  },
  SET_POST_IS_VIEWED: (state, id) => {
    state.posts[id].isViewed = true;
  },
};

const actions = {
  getPosts({ state, commit, rootGetters }) {
    // prevent duplicate requests from infinite scrolling
    if (state.isLoadingPosts) return;
    commit("SET_IS_LOADING_POSTS", true);
    SocialsService.retrievePosts({
      env: rootGetters["settings/getEnvironment"],
      limit: state.posts.length === 0 ? 2 : state.limit,
      skip: state.offset,
      source: rootGetters["stimulus/getViewer"],
    })
      .then((posts) => {
        let customPosts = posts;
        // manipulate posts before saving to store
        customPosts = posts.map((post) => {
          post.profilePic = post.pictures.find(((string)=>string.includes("profilePic")));          
          post.pictures.splice(post.pictures.indexOf(post.profilePic),1);
          post.bodyParsed = JSON.parse(post.body);
          post.isViewed = false;
          post.isLiked = false;
          post.isFollowed = false;
          return post;
        });
        // create and inject the stimulus post to first posts request
        if (state.posts.length === 0) {
          const stimulusSrc = rootGetters["stimulus/getStimulus"][0].src;
          const stimulusPost = generateStimulusPost(stimulusSrc);
          customPosts.splice(1, 0, stimulusPost);
        }
        commit("ADD_POSTS", customPosts);
        commit("SET_OFFSET", state.posts.length);
      })
      .catch((error) => {
        return Promise.reject(error);
      })
      .finally(() => {
        commit("SET_IS_LOADING_POSTS", false);
      });
  },
};

const generateStimulusPost = (stimulusSrc) => {
  return {
    isStimulus:true,
    bodyParsed: {
      header: {
        leftColumn: {
          imageUrl:
            "",
          innerImgUrl: "",
        },
        rightColumn: {
          topRow: {
            title: "Sponsor",
            verifiedAccount: "false",
          },
          bottomRow: {
            posterName: "",
            postedSince: "Sponsored",
            sponsored: false,
            public: false,
          },
        },
      },
      body: {
        topRow: {
          text: [],
        },
        bottomRow: {
          contentType: "video",
          image: {
            url: "https://media-cdn.incontext-research.com/facebook/users/102099916530784/posts/102099916530784_9044993432241343/image-src/image.jpeg",
          },
          video: {
            imageUrl: "",
            streamOriginalUrl: "",
            streamModifiedUrl: stimulusSrc,
          },
          link: {
            externalUrl: "",
            imageUrl: "",
            text: {
              domain: "",
              title: "",
              subtitle: "",
            },
          },
        },
      },
      footer: {
        reactionsCounter: Math.floor(Math.random() * 100),
        commentsCounter: Math.floor(Math.random() * 100),
      },
    },
    isViewed: false,
    isLiked: false,
    isFollowed: false,
    comments: [],
  };
};
export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
